import { ExitIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/nav';
import Panel from '@womcorp/wom-miwom-ui-kit/dist/components/Panel';

import Spinner from '@womcorp/wom-miwom-ui-kit/dist/components/Spinner/Spinner';
import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import {
  LoadingContainerStyled,
  LogoutContainerStyled,
  LogoutIconContainerStyled,
  LogoutTextContainerStyled,
} from './styles/LogoutStyled';
import LoginManagerServices from '../../../services/LoginManager';
import { GoogleTagManager } from '../../../helpers';
import useLogout from '../../../hooks/useLogout';
import LogoutRetry from '../../Logout/LogoutRetry';

const Logout = () => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const miwomLogout = useLogout();

  const handleClickLogout = () => {
    if (!loading) setLoading(true);

    LoginManagerServices.logout()
      .then(() => {
        GoogleTagManager.tagInteractiveEvent({
          eventCategory: 'Menu',
          eventAction: 'Seleccion_accion',
          eventTag: 'Cerrar Sesión',
        });
        miwomLogout();
      })
      .catch(err => {
        const { response: { status } = {} } = err;

        if (status >= 400 && status < 500) {
          GoogleTagManager.tagInteractiveEvent({
            eventCategory: 'Redirección MiWOM',
            eventAction: `Usuario Redireccionado - ${status}`,
            eventTag: 'Redirección MiWOM - Fallo Deslogeo',
          });
          miwomLogout();
        } else {
          setError(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const closeErrorPanel = () => {
    setError(false);
  };

  return (
    <>
      <Panel
        open={error}
        title="No es posible continuar"
        onClose={closeErrorPanel}
      >
        <LogoutRetry
          retry={handleClickLogout}
          close={closeErrorPanel}
          loading={loading}
        />
      </Panel>
      <LogoutContainerStyled
        onClick={() => {
          GoogleTagManager.tagInteractiveEvent({
            eventCategory: 'Elemento Menú',
            eventAction: `Presionar Botón - Cerrar Sesión`,
            eventTag: `Elemento Menú - ${isMobileDevice ? 'Burger' : 'Side'}`,
          });
          handleClickLogout();
        }}
        loading={loading}
      >
        <LogoutIconContainerStyled>
          <ExitIcon />
        </LogoutIconContainerStyled>
        <LogoutTextContainerStyled>
          <span>Cerrar</span> <strong>Sesión</strong>
        </LogoutTextContainerStyled>

        {loading && (
          <LoadingContainerStyled>
            <Spinner size={40} width={8} />
          </LoadingContainerStyled>
        )}
      </LogoutContainerStyled>
    </>
  );
};

export default Logout;
